import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkConfig } from '../../async-thunk-config';
import { VideoDownloadError } from './azimut-for-you-types';
import { VideoMediaResponse } from '../../../api/generated';
import apiManager from '../../../api/api-manager';

export const downloadVideos = createAsyncThunk<
  VideoMediaResponse,
  undefined,
  AsyncThunkConfig<VideoDownloadError>
>('download-videos', async (_, thunkApi) => {
  const token = thunkApi.getState().data?.user?.token;
  try {
    const response = await apiManager.media.getVideos({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
